import { presentDiscardClosureConfirmation } from 'owa-calendar-compose-form-actions';

export const closeItem = (formId: string, targetWindow: Window): void => {
    presentDiscardClosureConfirmation(formId, targetWindow);
};
